const LoadingSpinner = () => {
  return (
    <div className='loading'>
      <div className='spinner cube'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default LoadingSpinner;
